import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

interface DashboardPageContentProps {
  children: ReactNode;
  className?: string;
}

/** Centers dashboard page content with a readable max width on large screens. */
export function DashboardPageContent({ children, className }: DashboardPageContentProps) {
  return <div className={cn('mx-auto w-full min-w-0 max-w-7xl', className)}>{children}</div>;
}
